import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=6d9a879a&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=ts"
export * from "./Attribute.vue?vue&type=script&lang=ts"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=6d9a879a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a879a",
  null
  
)

export default component.exports